import { useCallback } from 'react';
import FormContext from './context';
import classnames from 'classnames';
import useForm from './useForm';

import styles from './form.module.scss';

import type { FC, ReactNode, FormHTMLAttributes, CSSProperties } from 'react';
import type { FormValue, FormErrors, UseFormRes } from './useForm';
import type { FormContextType } from './context';
import type { FormItemProps } from './item';

export interface FormProps extends FormHTMLAttributes<HTMLFormElement>, Pick<FormItemProps, 'labelProps' | 'requiredMark' > {
  form?: UseFormRes;
  onFinish?: (values: FormValue) => void;
  onFinishFailed?: (errors: FormErrors) => void;
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
  onChange?: () => void;
}

const Form: FC<FormProps> = (props) => {
  
  const {
    className,
    style,
    onFinish,
    onFinishFailed,
    children,
    form,
    labelProps,
    requiredMark = false,
    ...resetHtmlFormProps
  } = props;

  const prefixCls = 'web_components_form';

  const useFormInterface = useForm();

  const formInterface = form || useFormInterface;

  const formContext: FormContextType = formInterface;
  const { validateFields, validatorRules } = formInterface;

  const handleSubmit = useCallback(
    async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      try {
        const values = await validateFields();
        onFinish?.(values);
      } catch (errors: any) {
        onFinishFailed?.(errors);
        console.warn(errors);
      }
    },
    [onFinish, onFinishFailed, validatorRules]
  );


  return (
    <form
      className={classnames(styles[prefixCls], className)}
      style={style}
      {...resetHtmlFormProps}
      onSubmit={handleSubmit}
    >
      <FormContext.Provider 
        value={{
          ...formContext,
          labelProps,
          requiredMark
        }
        }>{children}</FormContext.Provider>
    </form>
  );
};

export default Form;